export const UPCOMING_STATUS_TAG_SX = {
    fontFamily: 'Open Sans',
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '16px',
    letterSpacing: '1px',
    textAlign: 'center',
    textTransform: 'uppercase',
} as const;

type UpcomingStatusTagProps = {
    label: string;
    fontColor: string;
    backgroundColor: string;
    sx: typeof UPCOMING_STATUS_TAG_SX;
};

export const getUpcomingStatusTagProps = (status: unknown): UpcomingStatusTagProps | null => {
    const normalizedStatus = String(status ?? '').toUpperCase();

    if (normalizedStatus === 'ACKNOWLEDGED' || normalizedStatus === 'SCHEDULED') {
        return {
            label: normalizedStatus,
            fontColor: '#0088F2',
            backgroundColor: '#E0F1FD',
            sx: UPCOMING_STATUS_TAG_SX,
        };
    }

    return null;
};
